import { Injectable, inject } from '@angular/core';
import { ActiveDevice, SupportedDevice } from '@finxone-platform/shared/sys-config-types';

import { ActiveConfigService } from '../../../../libs/services/active-config/active-config.service';

const DEVICE_TYPE = 'device_type';

@Injectable({
  providedIn: 'root',
})
export class MockDeviceTypeService {
  private _deviceType: SupportedDevice = ActiveDevice.MOBILE;

  activeStateConfig = inject(ActiveConfigService);

  get deviceType(): SupportedDevice {
    return this._deviceType;
  }

  set deviceType(value: SupportedDevice) {
    this._deviceType = value;
  }

  get currentdeviceType(): SupportedDevice {
    let deviceType = this.activeStateConfig.activeState.activeDevice;
    if (deviceType !== this._deviceType) {
      this._deviceType = deviceType;
      localStorage.setItem(DEVICE_TYPE, deviceType);
    }
    switch (this._deviceType) {
      case ActiveDevice.MOBILE: {
        deviceType = ActiveDevice.MOBILE;
        break;
      }
      case ActiveDevice.DESKTOP: {
        deviceType = ActiveDevice.DESKTOP;
        break;
      }
    }
    return deviceType;
  }
}
